/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrIndicatorProxyModule } from './igr-indicator-proxy-module';
import { IgrAccumulationDistributionIndicator } from './igr-accumulation-distribution-indicator';
import { AccumulationDistributionIndicator } from './AccumulationDistributionIndicator';
import { TypeRegistrar } from "igniteui-react-core";
var IgrAccumulationDistributionIndicatorModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrAccumulationDistributionIndicatorModule() {
    }
    IgrAccumulationDistributionIndicatorModule.register = function () {
        IgrIndicatorProxyModule.register();
        TypeRegistrar.registerCons("IgrAccumulationDistributionIndicator", IgrAccumulationDistributionIndicator);
        TypeRegistrar.register("AccumulationDistributionIndicator", AccumulationDistributionIndicator.$type);
    };
    return IgrAccumulationDistributionIndicatorModule;
}());
export { IgrAccumulationDistributionIndicatorModule };
